import * as React from 'react';

import StaticPageLayout from 'components/static-site/StaticPageLayout';
import {
  createStaticPageProps,
  staticPageFields,
  type StaticPageProps,
} from 'components/static-site/staticPageProps';
import type { CacheSafeGetServerSideProps } from 'declarations/shared/serverSideProps';
import type { WithRouterProps } from 'next/dist/client/with-router';
import { withRouter } from 'next/router';

import AccountFormPage from '../components/account/AccountFormPage';
import { pickAccountFormConfig, pickString } from '../components/account/accountFormPageParams';

const accountPageFields = staticPageFields(
  'login',
  'Log in | Opendoor',
  'Log in to your Opendoor account.',
);

export const getServerSideProps: CacheSafeGetServerSideProps<StaticPageProps> = async () => ({
  props: createStaticPageProps(accountPageFields),
});

export default withRouter((context: React.PropsWithChildren<WithRouterProps> & StaticPageProps) => {
  const { config, redirectTo, emailPrefill, updatedPassword } = context.router.query;
  return (
    <StaticPageLayout {...context} hideFooter>
      <AccountFormPage
        config={pickAccountFormConfig(config)}
        redirectTo={pickString(redirectTo)}
        emailPrefill={pickString(emailPrefill)}
        updatedPassword={pickString(updatedPassword) === 'true'}
      />
    </StaticPageLayout>
  );
});
